import Vue from 'vue';
import VueRouter from 'vue-router';
import {QuestionnaireRoutes} from '@/router/questionnaire';
import {MainRoutes} from './main';
import {OfficialRoutes} from './official';
import {RuleRoutes} from './rule';
import AnnalsView from '@/views/annals/index.vue';
import AvaView from '@/views/ava/index.vue';
import LoginView from '@/views/login/index.vue';
import {MediaRoutes} from '@/router/media';
import {TerminalRoutes} from '@/router/terminal';

Vue.use(VueRouter);

/**
 * 路由集合,Vue初始化载入对象
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL, //本地代理url
  routes: [
    {
      path: '/',
      name: 'official',
      redirect: '/index/home',
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      //H5年度汇报,目前迁移至 小程序
      path: '/annals',
      name: 'annals',
      component: AnnalsView,
    },
    {
      name: 'ava',
      path: '/ava',
      component: AvaView
    },
    ...MainRoutes,
    ...QuestionnaireRoutes,
    ...OfficialRoutes,
    ...MediaRoutes,
    ...TerminalRoutes
  ],
});

export default router;
